import React, { useState, useEffect } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { saveAs } from "file-saver";
import moment from "moment";
import { encode } from "url-safe-base64";
import { withStyles } from "@material-ui/core/styles";
import axios from "axios";

import Grid from "@material-ui/core/Grid";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Switch from "../../components/Switch";
import * as clipboard from "clipboard-polyfill/text";
import Alert from "@material-ui/lab/Alert";

import Fab from "@material-ui/core/Fab";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import ScrollTop from "../../components/ScrollTop";
import { useTranslation } from "react-i18next";

const GooglePlay = () => {
	return (
		<svg
			width="115"
			height="28"
			viewBox="0 0 115 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="115" height="28" rx="3" fill="black" />
			<g clipPath="url(#clip0)">
				<path
					d="M26.4167 15C26.4167 15.4375 26.1717 15.8225 25.8158 16.0208L22.7825 17.7067L20.2158 15L22.7825 12.2933L25.8158 13.9792C26.1717 14.1775 26.4167 14.5625 26.4167 15Z"
					fill="#FECD2F"
				/>
				<path
					d="M20.2155 15L13.9155 21.6442C13.7055 21.4342 13.583 21.1483 13.583 20.8333V9.16667C13.583 8.85167 13.7055 8.56583 13.9155 8.35583L20.2155 15Z"
					fill="#23CEFD"
				/>
				<path
					d="M20.216 15L22.7827 17.7067C15.0984 21.9212 14.7764 22.5524 13.916 21.6442L20.216 15Z"
					fill="#F4374D"
				/>
				<path
					d="M22.7827 12.2933L20.216 15L13.916 8.35583C14.2765 7.97492 14.8546 7.8915 15.316 8.14583L22.7827 12.2933Z"
					fill="#27EE7B"
				/>
			</g>
			<path
				d="M44.5117 17.9219C44.1953 18.3008 43.748 18.5957 43.1699 18.8066C42.5918 19.0137 41.9512 19.1172 41.248 19.1172C40.5098 19.1172 39.8613 18.957 39.3027 18.6367C38.748 18.3125 38.3184 17.8438 38.0137 17.2305C37.7129 16.6172 37.5586 15.8965 37.5508 15.0684V14.4883C37.5508 13.6367 37.6934 12.9004 37.9785 12.2793C38.2676 11.6543 38.6816 11.1777 39.2207 10.8496C39.7637 10.5176 40.3984 10.3516 41.125 10.3516C42.1367 10.3516 42.9277 10.5938 43.498 11.0781C44.0684 11.5586 44.4062 12.2598 44.5117 13.1816H42.8008C42.7227 12.6934 42.5488 12.3359 42.2793 12.1094C42.0137 11.8828 41.6465 11.7695 41.1777 11.7695C40.5801 11.7695 40.125 11.9941 39.8125 12.4434C39.5 12.8926 39.3418 13.5605 39.3379 14.4473V14.9922C39.3379 15.8867 39.5078 16.5625 39.8477 17.0195C40.1875 17.4766 40.6855 17.7051 41.3418 17.7051C42.002 17.7051 42.4727 17.5645 42.7539 17.2832V15.8125H41.1543V14.5176H44.5117V17.9219ZM45.6864 15.7715C45.6864 15.1426 45.8075 14.582 46.0497 14.0898C46.2919 13.5977 46.6395 13.2168 47.0927 12.9473C47.5497 12.6777 48.079 12.543 48.6805 12.543C49.536 12.543 50.2333 12.8047 50.7723 13.3281C51.3153 13.8516 51.618 14.5625 51.6805 15.4609L51.6923 15.8945C51.6923 16.8672 51.4208 17.6484 50.8778 18.2383C50.3348 18.8242 49.6063 19.1172 48.6923 19.1172C47.7782 19.1172 47.0477 18.8242 46.5009 18.2383C45.9579 17.6523 45.6864 16.8555 45.6864 15.8477V15.7715ZM47.3798 15.8945C47.3798 16.4961 47.493 16.957 47.7196 17.2773C47.9462 17.5938 48.2704 17.752 48.6923 17.752C49.1024 17.752 49.4227 17.5957 49.6532 17.2832C49.8837 16.9668 49.9989 16.4629 49.9989 15.7715C49.9989 15.1816 49.8837 14.7246 49.6532 14.4004C49.4227 14.0762 49.0985 13.9141 48.6805 13.9141C48.2665 13.9141 47.9462 14.0762 47.7196 14.4004C47.493 14.7207 47.3798 15.2188 47.3798 15.8945ZM52.5916 15.7715C52.5916 15.1426 52.7127 14.582 52.9548 14.0898C53.197 13.5977 53.5447 13.2168 53.9978 12.9473C54.4548 12.6777 54.9841 12.543 55.5857 12.543C56.4412 12.543 57.1384 12.8047 57.6775 13.3281C58.2205 13.8516 58.5232 14.5625 58.5857 15.4609L58.5974 15.8945C58.5974 16.8672 58.3259 17.6484 57.783 18.2383C57.24 18.8242 56.5115 19.1172 55.5974 19.1172C54.6834 19.1172 53.9529 18.8242 53.406 18.2383C52.863 17.6523 52.5916 16.8555 52.5916 15.8477V15.7715ZM54.2849 15.8945C54.2849 16.4961 54.3982 16.957 54.6248 17.2773C54.8513 17.5938 55.1755 17.752 55.5974 17.752C56.0076 17.752 56.3279 17.5957 56.5584 17.2832C56.7888 16.9668 56.9041 16.4629 56.9041 15.7715C56.9041 15.1816 56.7888 14.7246 56.5584 14.4004C56.3279 14.0762 56.0037 13.9141 55.5857 13.9141C55.1716 13.9141 54.8513 14.0762 54.6248 14.4004C54.3982 14.7207 54.2849 15.2188 54.2849 15.8945ZM59.5143 15.7832C59.5143 14.8105 59.7448 14.0273 60.2057 13.4336C60.6705 12.8398 61.2955 12.543 62.0807 12.543C62.776 12.543 63.317 12.7812 63.7038 13.2578L63.7741 12.6602H65.3092V18.7891C65.3092 19.3438 65.1823 19.8262 64.9284 20.2363C64.6784 20.6465 64.3248 20.959 63.8678 21.1738C63.4108 21.3887 62.8756 21.4961 62.2623 21.4961C61.7975 21.4961 61.3444 21.4023 60.903 21.2148C60.4616 21.0312 60.1276 20.793 59.901 20.5L60.651 19.4688C61.0729 19.9414 61.5846 20.1777 62.1862 20.1777C62.6354 20.1777 62.985 20.0566 63.235 19.8145C63.485 19.5762 63.61 19.2363 63.61 18.7949V18.4551C63.2194 18.8965 62.7057 19.1172 62.069 19.1172C61.3073 19.1172 60.6901 18.8203 60.2174 18.2266C59.7487 17.6289 59.5143 16.8379 59.5143 15.8535V15.7832ZM61.2077 15.9062C61.2077 16.4805 61.3229 16.9316 61.5534 17.2598C61.7838 17.584 62.1002 17.7461 62.5026 17.7461C63.0182 17.7461 63.3873 17.5527 63.61 17.166V14.5C63.3834 14.1133 63.0182 13.9199 62.5143 13.9199C62.108 13.9199 61.7877 14.0859 61.5534 14.418C61.3229 14.75 61.2077 15.2461 61.2077 15.9062ZM68.523 19H66.8237V10H68.523V19ZM72.9613 19.1172C72.0316 19.1172 71.2738 18.832 70.6879 18.2617C70.1059 17.6914 69.8148 16.9316 69.8148 15.9824V15.8184C69.8148 15.1816 69.9379 14.6133 70.184 14.1133C70.4301 13.6094 70.7777 13.2227 71.227 12.9531C71.6801 12.6797 72.1957 12.543 72.7738 12.543C73.641 12.543 74.3227 12.8164 74.8187 13.3633C75.3187 13.9102 75.5687 14.6855 75.5687 15.6895V16.3809H71.5316C71.5863 16.7949 71.7504 17.127 72.0238 17.377C72.3012 17.627 72.6508 17.752 73.0727 17.752C73.725 17.752 74.2348 17.5156 74.602 17.043L75.434 17.9746C75.1801 18.334 74.8363 18.6152 74.4027 18.8184C73.9691 19.0176 73.4887 19.1172 72.9613 19.1172ZM72.768 13.9141C72.432 13.9141 72.1586 14.0273 71.9477 14.2539C71.7406 14.4805 71.6078 14.8047 71.5492 15.2266H73.9047V15.0918C73.8969 14.7168 73.7953 14.4277 73.6 14.2246C73.4047 14.0176 73.1273 13.9141 72.768 13.9141ZM81.633 15.9941V19H79.8752V10.4688H83.2033C83.8439 10.4688 84.4064 10.5859 84.8908 10.8203C85.3791 11.0547 85.7541 11.3887 86.0158 11.8223C86.2775 12.252 86.4084 12.7422 86.4084 13.293C86.4084 14.1289 86.1213 14.7891 85.547 15.2734C84.9767 15.7539 84.1857 15.9941 83.174 15.9941H81.633ZM81.633 14.5703H83.2033C83.6681 14.5703 84.0216 14.4609 84.2638 14.2422C84.5099 14.0234 84.633 13.7109 84.633 13.3047C84.633 12.8867 84.5099 12.5488 84.2638 12.291C84.0177 12.0332 83.6779 11.9004 83.2443 11.8926H81.633V14.5703ZM89.417 19H87.7178V10H89.417V19ZM94.6113 19C94.5331 18.8477 94.4765 18.6582 94.4413 18.4316C94.0312 18.8887 93.498 19.1172 92.8417 19.1172C92.2206 19.1172 91.705 18.9375 91.2948 18.5781C90.8886 18.2188 90.6855 17.7656 90.6855 17.2188C90.6855 16.5469 90.9335 16.0312 91.4296 15.6719C91.9296 15.3125 92.6503 15.1309 93.5917 15.127H94.371V14.7637C94.371 14.4707 94.2948 14.2363 94.1425 14.0605C93.9941 13.8848 93.7577 13.7969 93.4335 13.7969C93.1484 13.7969 92.9238 13.8652 92.7597 14.002C92.5995 14.1387 92.5195 14.3262 92.5195 14.5645H90.8261C90.8261 14.1973 90.9394 13.8574 91.1659 13.5449C91.3925 13.2324 91.7128 12.9883 92.1269 12.8125C92.5409 12.6328 93.0058 12.543 93.5214 12.543C94.3027 12.543 94.9218 12.7402 95.3788 13.1348C95.8398 13.5254 96.0702 14.0762 96.0702 14.7871V17.5352C96.0741 18.1367 96.1581 18.5918 96.3222 18.9004V19H94.6113ZM93.2109 17.8223C93.4609 17.8223 93.6913 17.7676 93.9023 17.6582C94.1132 17.5449 94.2695 17.3945 94.371 17.207V16.1172H93.7382C92.8905 16.1172 92.4394 16.4102 92.3847 16.9961L92.3788 17.0957C92.3788 17.3066 92.453 17.4805 92.6015 17.6172C92.7499 17.7539 92.953 17.8223 93.2109 17.8223ZM99.7645 16.6035L100.936 12.6602H102.753L100.204 19.9844L100.063 20.3184C99.6844 21.1465 99.0594 21.5605 98.1883 21.5605C97.9422 21.5605 97.6922 21.5234 97.4383 21.4492V20.166L97.6961 20.1719C98.0164 20.1719 98.2547 20.123 98.4109 20.0254C98.5711 19.9277 98.6961 19.7656 98.7859 19.5391L98.9852 19.0176L96.7645 12.6602H98.5867L99.7645 16.6035Z"
				fill="white"
			/>
			<defs>
				<clipPath id="clip0">
					<rect
						width="14"
						height="14"
						fill="white"
						transform="translate(13 8)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

const ApplePlay = () => (
	<svg
		width="115"
		height="28"
		viewBox="0 0 115 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="115" height="28" rx="3" fill="black" />
		<path
			d="M41.5781 17.2422H38.4961L37.9102 19H36.041L39.2168 10.4688H40.8457L44.0391 19H42.1699L41.5781 17.2422ZM38.9707 15.8184H41.1035L40.0312 12.625L38.9707 15.8184ZM50.2704 15.8887C50.2704 16.8652 50.0477 17.6484 49.6024 18.2383C49.161 18.8242 48.5634 19.1172 47.8095 19.1172C47.1688 19.1172 46.6512 18.8945 46.2567 18.4492V21.4375H44.5634V12.6602H46.1337L46.1923 13.2812C46.6024 12.7891 47.1376 12.543 47.7977 12.543C48.579 12.543 49.1864 12.832 49.62 13.4102C50.0536 13.9883 50.2704 14.7852 50.2704 15.8008V15.8887ZM48.577 15.7656C48.577 15.1758 48.4716 14.7207 48.2606 14.4004C48.0536 14.0801 47.7509 13.9199 47.3524 13.9199C46.8212 13.9199 46.4559 14.123 46.2567 14.5293V17.125C46.4637 17.543 46.8329 17.752 47.3641 17.752C48.1727 17.752 48.577 17.0898 48.577 15.7656ZM57.1521 15.8887C57.1521 16.8652 56.9295 17.6484 56.4841 18.2383C56.0427 18.8242 55.4451 19.1172 54.6912 19.1172C54.0505 19.1172 53.533 18.8945 53.1384 18.4492V21.4375H51.4451V12.6602H53.0154L53.074 13.2812C53.4841 12.7891 54.0193 12.543 54.6795 12.543C55.4607 12.543 56.0681 12.832 56.5017 13.4102C56.9353 13.9883 57.1521 14.7852 57.1521 15.8008V15.8887ZM55.4587 15.7656C55.4587 15.1758 55.3533 14.7207 55.1423 14.4004C54.9353 14.0801 54.6326 13.9199 54.2341 13.9199C53.7029 13.9199 53.3377 14.123 53.1384 14.5293V17.125C53.3455 17.543 53.7146 17.752 54.2459 17.752C55.0545 17.752 55.4587 17.0898 55.4587 15.7656ZM65.9702 16.7617C65.9702 16.4297 65.853 16.1758 65.6187 16C65.3843 15.8203 64.9624 15.6328 64.353 15.4375C63.7437 15.2383 63.2612 15.043 62.9058 14.8516C61.937 14.3281 61.4527 13.623 61.4527 12.7363C61.4527 12.2754 61.5816 11.8652 61.8394 11.5059C62.1011 11.1426 62.4741 10.8594 62.9585 10.6562C63.4468 10.4531 63.9937 10.3516 64.5991 10.3516C65.2085 10.3516 65.7515 10.4629 66.228 10.6855C66.7046 10.9043 67.0737 11.2148 67.3355 11.6172C67.6011 12.0195 67.7339 12.4766 67.7339 12.9883H65.9761C65.9761 12.5977 65.853 12.2949 65.607 12.0801C65.3609 11.8613 65.0152 11.752 64.5698 11.752C64.1402 11.752 63.8062 11.8438 63.5679 12.0273C63.3296 12.207 63.2105 12.4453 63.2105 12.7422C63.2105 13.0195 63.3491 13.252 63.6265 13.4395C63.9077 13.627 64.3198 13.8027 64.8628 13.9668C65.8628 14.2676 66.5913 14.6406 67.0484 15.0859C67.5054 15.5312 67.7339 16.0859 67.7339 16.75C67.7339 17.4883 67.4546 18.0684 66.896 18.4902C66.3374 18.9082 65.5855 19.1172 64.6402 19.1172C63.9839 19.1172 63.3862 18.998 62.8472 18.7598C62.3081 18.5176 61.896 18.1875 61.6109 17.7695C61.3296 17.3516 61.189 16.8672 61.189 16.3164H62.9527C62.9527 17.2578 63.5152 17.7285 64.6402 17.7285C65.0581 17.7285 65.3843 17.6445 65.6187 17.4766C65.853 17.3047 65.9702 17.0664 65.9702 16.7617ZM70.9652 11.1016V12.6602H72.0492V13.9023H70.9652V17.0664C70.9652 17.3008 71.0102 17.4688 71.1 17.5703C71.1898 17.6719 71.3617 17.7227 71.6156 17.7227C71.8031 17.7227 71.9691 17.709 72.1137 17.6816V18.9648C71.7816 19.0664 71.4398 19.1172 71.0883 19.1172C69.9008 19.1172 69.2953 18.5176 69.2719 17.3184V13.9023H68.3461V12.6602H69.2719V11.1016H70.9652ZM72.6731 15.7715C72.6731 15.1426 72.7942 14.582 73.0364 14.0898C73.2786 13.5977 73.6263 13.2168 74.0794 12.9473C74.5364 12.6777 75.0657 12.543 75.6673 12.543C76.5227 12.543 77.22 12.8047 77.7591 13.3281C78.302 13.8516 78.6048 14.5625 78.6673 15.4609L78.679 15.8945C78.679 16.8672 78.4075 17.6484 77.8645 18.2383C77.3216 18.8242 76.593 19.1172 75.679 19.1172C74.7649 19.1172 74.0345 18.8242 73.4876 18.2383C72.9446 17.6523 72.6731 16.8555 72.6731 15.8477V15.7715ZM74.3665 15.8945C74.3665 16.4961 74.4798 16.957 74.7063 17.2773C74.9329 17.5938 75.2571 17.752 75.679 17.752C76.0891 17.752 76.4095 17.5957 76.6399 17.2832C76.8704 16.9668 76.9856 16.4629 76.9856 15.7715C76.9856 15.1816 76.8704 14.7246 76.6399 14.4004C76.4095 14.0762 76.0852 13.9141 75.6673 13.9141C75.2532 13.9141 74.9329 14.0762 74.7063 14.4004C74.4798 14.7207 74.3665 15.2188 74.3665 15.8945ZM83.4045 14.248C83.174 14.2168 82.9709 14.2012 82.7951 14.2012C82.1545 14.2012 81.7345 14.418 81.5353 14.8516V19H79.842V12.6602H81.4416L81.4884 13.416C81.8283 12.834 82.299 12.543 82.9005 12.543C83.088 12.543 83.2638 12.5684 83.4279 12.6191L83.4045 14.248ZM87.1455 19.1172C86.2159 19.1172 85.458 18.832 84.8721 18.2617C84.2901 17.6914 83.9991 16.9316 83.9991 15.9824V15.8184C83.9991 15.1816 84.1221 14.6133 84.3682 14.1133C84.6143 13.6094 84.962 13.2227 85.4112 12.9531C85.8643 12.6797 86.3799 12.543 86.958 12.543C87.8252 12.543 88.5069 12.8164 89.003 13.3633C89.503 13.9102 89.753 14.6855 89.753 15.6895V16.3809H85.7159C85.7705 16.7949 85.9346 17.127 86.208 17.377C86.4854 17.627 86.835 17.752 87.2569 17.752C87.9092 17.752 88.419 17.5156 88.7862 17.043L89.6182 17.9746C89.3643 18.334 89.0205 18.6152 88.587 18.8184C88.1534 19.0176 87.6729 19.1172 87.1455 19.1172ZM86.9522 13.9141C86.6162 13.9141 86.3428 14.0273 86.1319 14.2539C85.9248 14.4805 85.792 14.8047 85.7334 15.2266H88.0889V15.0918C88.0811 14.7168 87.9795 14.4277 87.7842 14.2246C87.5889 14.0176 87.3116 13.9141 86.9522 13.9141Z"
			fill="white"
		/>
		<path
			d="M16.789 22C14.4077 21.9863 12.438 17.1253 12.438 14.6497C12.438 10.6058 15.4716 9.7205 16.6407 9.7205C17.1676 9.7205 17.7302 9.92741 18.2264 10.1105C18.5734 10.2382 18.9323 10.3701 19.1319 10.3701C19.2513 10.3701 19.5329 10.2579 19.7814 10.1595C20.3115 9.94847 20.9711 9.68619 21.7393 9.68619C21.7406 9.68619 21.7425 9.68619 21.7438 9.68619C22.3174 9.68619 24.0565 9.81206 25.102 11.3822L25.3469 11.7502L24.9944 12.0162C24.4909 12.3961 23.5721 13.0892 23.5721 14.462C23.5721 16.088 24.6126 16.7133 25.1125 17.0141C25.3332 17.1468 25.5616 17.2837 25.5616 17.5831C25.5616 17.7785 24.0015 21.9757 21.7361 21.9757C21.1817 21.9757 20.7899 21.8091 20.4442 21.6622C20.0945 21.5134 19.7928 21.3852 19.2943 21.3852C19.0416 21.3852 18.7221 21.5047 18.3838 21.6315C17.9216 21.8041 17.3983 22 16.8046 22H16.789Z"
			fill="white"
		/>
		<path
			d="M21.979 6C22.038 8.12737 20.5166 9.60325 18.997 9.51069C18.7466 7.81297 20.5165 6 21.979 6Z"
			fill="white"
		/>
	</svg>
);

const Promotion = (props) => {
	const { classes, webcode, universalLink } = props;
	const [isActiveAlert, setIsActiveAlert] = useState(false);
	const [isActiveStores, setIsActiveStores] = useState(true);
	const [b64Value, setB64Value] = useState(null);
	// let baseUrl = window.location.origin === 'http://localhost:3000' ? 'http://localhost/' : '/';
	let baseUrl = "https://e-admin.com.ua/";

	const { t } = useTranslation();

	const isMin600 = useMediaQuery("(max-width: 599px)");
	const isMax600 = useMediaQuery("(min-width: 600px)");

	const copyText = () => {
		clipboard
			.writeText(webcode)
			.then(() => setIsActiveAlert(true))
			.catch(() => console.log("Error write text!"));
		setTimeout(() => setIsActiveAlert(false), 2000);
	};

	const handleIconsStore = () => {
		setIsActiveStores(!isActiveStores);
	};

	const downloadFile = (absoluteUrl) => {
		console.log("click, 1");
		// http://localhost or /

		var url = baseUrl + `qr_code/get_qr.php?url=${absoluteUrl}`;
		var xhr = new XMLHttpRequest();
		xhr.onload = function () {
			var codes = new Uint8Array(xhr.response);
			var bin = String.fromCharCode.apply(null, codes);

			var b64 = btoa(bin);

			if (!b64Value) {
				setB64Value(b64);
			}

			if (b64 === b64Value) {
				let date = moment(new Date()).format("YYYYMMDDHHmmss");
				saveAs(`data:image/png;base64, ${b64Value}`, `qr_code_${date}.png`);
			}
		};

		xhr.open("GET", absoluteUrl);
		xhr.responseType = "arraybuffer";
		xhr.send();
	};

	useEffect(() => {
		if (b64Value) {
			saveAs(`data:image/png;base64, ${b64Value}`, `qr_code.png`);
		}
	}, [b64Value]);

	return (
		<div id="promotion-id">
			{isMin600 && (
				<Typography className={classes.titleMobile} variant="h1">
					{t("navigation.promotion")}
				</Typography>
			)}
			<Grid
				className={classes.container}
				direction={"row"}
				container
				alignItems={"center"}
			>
				<Grid item xs={12}>
					{isMax600 && (
						<Typography className={classes.title} variant="h1">
							{t("navigation.promotion")}
						</Typography>
					)}
					{!!webcode && (
						<div className={classes.typographyWrapper}>
							<Typography className={classes.h6} variant="h6">
								Код для вставки сайта
							</Typography>
							{isMin600 && (
								<div className={classes.buttonWrapper}>
									<Button
										onClick={copyText}
										className={classes.button}
										variant="contained"
										color="primary"
									>
										Скопировать
									</Button>
								</div>
							)}
						</div>
					)}

					{!!webcode && (
						<div className={classes.codeWrapper}>
							<TextareaAutosize
								className={classes.textarea}
								rowsMax={4}
								aria-label=""
								placeholder=""
								defaultValue={props.webcode}
							/>
							<div className={classes.textareaContent}>
								<div className={classes.textareaText}>
									<p className={classes.textareaParagraph}>
										Этот скрипт нужно вставить на сайт между тегов{" "}
										<strong>{`<head></head>`}</strong>.
									</p>
									<p className={classes.textareaParagraph}>
										Все посетители сайта увидят, что у вас появилось мобильное
										приложение.
									</p>
								</div>
								{isMax600 && (
									<div className={classes.buttonWrapper}>
										<Button
											onClick={copyText}
											className={classes.button}
											variant="contained"
											color="primary"
										>
											Скопировать
										</Button>
									</div>
								)}
							</div>
							{isActiveAlert && (
								<Alert className={classes.alert} severity="info">
									Текст был успешно скопирован!
								</Alert>
							)}
						</div>
					)}
					<div className={classes.qrCodeWrapper}>
						<div className={classes.qrCode}>
							<h3 className={classes.qrTitle}>{t("promotion.qr")}</h3>
							<div className={classes.qrCodeData}>
								<img
									className={classes.qrImage}
									src={baseUrl + `qr_code/get_qr.php?url=${universalLink}`}
									alt={`QR Code ${universalLink}`}
								/>
								{/* {isActiveStores && <GooglePlay />}
                                {isActiveStores && <ApplePlay />} */}
							</div>
							{/* <div className={classes.qrCodeInfo}>
                                <div className={classes.qrcodeText}>Включить значки AppStore & Google Play</div>
                                <div className={classes.qrcodeCheckBox}>
                                <Switch 
                                    className={classes.switchComponent} 
                                    active={isActiveStores}
                                    changeChecker={handleIconsStore} /> 
                                </div>
                            </div> */}
							<div className={classes.qrCodeWebsite}>
								<div
									className={classes.qrDownloadFile}
									onClick={() =>
										downloadFile(
											baseUrl + `qr_code/get_qr.php?url=${universalLink}`
										)
									}
								>
									{t("promotion.saveQr")}
								</div>
							</div>
						</div>
						<div className={classes.text}>
							<p className={classes.paragraph}>{t("promotion.article.par1")}</p>
							<p className={classes.paragraph}>{t("promotion.article.par2")}</p>
							<p className={classes.paragraph}>{t("promotion.article.par3")}</p>
							<strong>{t("promotion.article.sizes")}</strong>
							<ul className={classes.textList}>
								<li className={classes.textParagraph}>
									{t("promotion.article.par4")}
								</li>
								<li className={classes.textParagraph}>
									{t("promotion.article.par5")}
								</li>
							</ul>
						</div>
					</div>
					<div className={classes.advertising}>
						<h2 className={classes.advertising__title}>
							{t("promotion.article.par6")}
						</h2>
						<p className={classes.advertising__paragraph}>
							{t("promotion.article.par7")}
						</p>
					</div>
					<ScrollTop {...props} id={"#promotion-id"}>
						<Fab
							className={classes.arrowUp}
							color="primary"
							size="small"
							aria-label="scroll back to top"
						>
							<KeyboardArrowUpIcon />
						</Fab>
					</ScrollTop>
				</Grid>
			</Grid>
		</div>
	);
};

const styles = (theme) => ({
	container: {
		padding: 16,
		borderRadius: 5,
		background: "white",
		border: "0.5px solid #DADCE0",
	},
	title: {
		fontSize: 22,
		fontWeight: "bold",
		lineHeight: "26px",
	},
	titleMobile: {
		marginTop: 16,
		marginBottom: 8,
		fontSize: 22,
		fontWeight: "bold",
		lineHeight: "26px",
	},
	typographyWrapper: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
	},
	h6: {
		marginTop: 20,
		fontSize: 16,
		lineHeight: "19px",
		fontWeight: 500,
		[theme.breakpoints.down("600")]: {
			marginTop: 0,
		},
	},
	textarea: {
		marginTop: 13,
		marginBottom: 5,
		width: "100%",
		height: "86px !important",
		padding: "10px 16px",
		fontSize: 16,
		lineHeight: "24px",
		letterSpacing: "0.15px",
		color: "#476282",
		border: "0.5px solid #DADCE0",
		boxSizing: "border-box",
		borderRadius: "5px",
		resize: "none",
		overflowY: "auto !important",
	},
	textareaContent: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
	},
	textareaParagraph: {
		margin: 0,
		lineHeight: "24px",
	},
	button: {
		width: 109,
		height: 36,
		background: "#E9F1FC",
		borderRadius: "5px",
		fontSize: 14,
		textTransform: "none",
		fontWeight: 500,
		boxShadow: "none",
		border: "none",
		color: "#326DFF",
		"&:hover": {
			background: "rgb(50, 109, 255);",
			color: "white",
			boxShadow: "none",
			border: "none",
		},
	},
	qrCodeWrapper: {
		marginTop: 16,
		display: "flex",
		border: "0.5px solid #DADCE0",
		boxSizing: "border-box",
		borderRadius: 5,
		padding: "24px 16px",
		[theme.breakpoints.down("600")]: {
			flexDirection: "column",
			border: "none",
			padding: 0,
			marginTop: 24,
		},
	},
	qrCode: {
		width: 215,
		[theme.breakpoints.down("600")]: {
			width: "100%",
		},
	},
	qrCodeData: {
		marginTop: 15,
		marginBottom: 15,
		width: 147,
		height: "auto",
		padding: 16,
		border: "0.5px solid #DADCE0",
		boxSizing: "border-box",
		borderRadius: 5,
		[theme.breakpoints.down("600")]: {
			flexDirection: "column",
			margin: "16px auto",
		},
	},
	qrTitle: {
		fontSize: 16,
		lineHeight: "19px",
		margin: 0,
	},
	text: {
		marginLeft: 100,
		maxWidth: 418,
		[theme.breakpoints.down("600")]: {
			marginLeft: 0,
			maxWidth: "100%",
		},
		"& > p:first-child": {
			marginTop: 0,
		},
	},
	qrCodeInfo: {
		display: "flex",
		[theme.breakpoints.down("600")]: {
			width: 230,
			margin: "0 auto",
		},
	},
	qrCodeWebsite: {
		marginTop: 15,
		[theme.breakpoints.down("600")]: {
			marginTop: 24,
			marginBottom: 16,
			textAlign: "center",
		},
	},
	qrcodeText: {
		width: 160,
		[theme.breakpoints.down("600")]: {
			width: 180,
		},
	},
	qrImage: {
		width: "100%",
	},
	advertising: {
		marginTop: 16,
		padding: "24px 16px",
		border: "0.5px solid #DADCE0",
		boxSizing: "border-box",
		borderRadius: 5,
		[theme.breakpoints.down("600")]: {
			marginTop: 24,
			padding: 0,
			border: "none",
			"& > h2": {
				fontSize: 20,
				marginBottom: 12,
			},
		},
	},
	alert: {
		marginTop: 10,
	},
	textList: {
		margin: 0,
		listStyleType: "none",
		padding: 0,
	},
	qrDownloadFile: {
		color: "#326dff",
		cursor: "pointer",
	},
	arrowUp: {
		background: "#326dff",
	},
});

export default withStyles(styles, { withTheme: true })(Promotion);
